export default __webpack_public_path__ + "static/media/img-0731-latvia-full-face.0623418b.png";